import { render } from "./Hotspot11.vue?vue&type=template&id=df7cc1a4&scoped=true&ts=true"
import script from "./Hotspot11.vue?vue&type=script&lang=ts"
export * from "./Hotspot11.vue?vue&type=script&lang=ts"

import "./Hotspot11.vue?vue&type=style&index=0&id=df7cc1a4&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df7cc1a4"]])

export default __exports__